// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3v_cj","head":"Table_head__2LVRi","col":"Table_col__2HIIb"};